<template>
  <div class="login-page">
    <div class="main-content">
      <div class="login-card">
        <div class="title">系统登录</div>

        <el-form
          ref="formRef"
          :model="form"
          :rules="rules"
          label-position="top"
          @submit.prevent
        >
          <el-form-item label="账号" prop="username">
            <el-input
              v-model="form.username"
              placeholder="请输入账号"
              autocomplete="username"
              @keyup.enter="onSubmit"
            />
          </el-form-item>

          <el-form-item label="密码" prop="password">
            <el-input
              v-model="form.password"
              type="password"
              show-password
              placeholder="请输入密码"
              autocomplete="current-password"
              @keyup.enter="onSubmit"
            />
          </el-form-item>

          <el-button
            type="primary"
            class="login-btn"
            :loading="loading"
            @click="onSubmit"
          >
            登录
          </el-button>

          <div class="hint">请输入账号密码登入系统</div>
        </el-form>
      </div>
    </div>
    <div class="company">上海申远特种线缆股份有限公司</div>
  </div>
</template>

<script>
import { reactive, ref } from 'vue'
import { ElMessage } from 'element-plus'
import { apiUrl } from '../api/config'

export default {
  name: 'LoginPage',
  emits: ['success'],
  setup(_, { emit }) {
    const formRef = ref(null)
    const loading = ref(false)

    const form = reactive({
      username: '',
      password: ''
    })

    const rules = {
      username: [{ required: true, message: '请输入账号', trigger: 'blur' }],
      password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
    }

    const onSubmit = async () => {
      if (loading.value) return

      const ok = await formRef.value?.validate?.().catch(() => false)
      if (!ok) return

      loading.value = true
      try {
        const url = apiUrl('/Api/Auth/Login')
        const res = await fetch(url, {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            userName: form.username,
            password: form.password
          })
        })

        const json = await res.json()

        // 处理不同的响应码
        if (json.code === 0) {
          // 登录成功
          const data = json.data
          localStorage.setItem('token', data.token)
          localStorage.setItem('userName', data.userName)
          localStorage.setItem('expireAt', data.expireAt)

          ElMessage.success('登录成功')
          emit('success', { username: data.userName, token: data.token })
        } else if (json.code === 1) {
          // 密码需修改
          ElMessage.warning(json.message || '密码不符合规则，请先登录ERP系统修改密码')
        } else {
          // 其他错误
          ElMessage.error(json.message || '用户名或密码错误')
        }
      } catch (e) {
        ElMessage.error('登录失败，请稍后重试')
      } finally {
        loading.value = false
      }
    }

    return {
      formRef,
      form,
      rules,
      loading,
      onSubmit
    }
  }
}
</script>

<style scoped>
.login-page {
  position: relative;
  overflow: hidden;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px;
  background:
    radial-gradient(900px 500px at 12% 15%, rgba(143, 211, 255, 0.32) 0%, rgba(143, 211, 255, 0) 70%),
    radial-gradient(700px 400px at 88% 8%, rgba(176, 224, 170, 0.32) 0%, rgba(176, 224, 170, 0) 72%),
    linear-gradient(145deg, #eef5ff 0%, #f5fbf6 52%, #f6f9ff 100%);
}

.login-page::before,
.login-page::after {
  content: '';
  position: absolute;
  border-radius: 50%;
  filter: blur(6px);
  pointer-events: none;
}

.login-page::before {
  width: 320px;
  height: 320px;
  left: -120px;
  bottom: -140px;
  background: rgba(118, 171, 255, 0.18);
}

.login-page::after {
  width: 260px;
  height: 260px;
  right: -90px;
  top: 40px;
  background: rgba(134, 209, 153, 0.2);
}

.main-content {
  position: relative;
  z-index: 1;
  flex: 1;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-card {
  width: 100%;
  max-width: 380px;
  padding: 24px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.85);
  border: 1px solid rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(8px);
  box-shadow: 0 14px 38px rgba(42, 76, 145, 0.14);
}

.title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 16px;
  color: #1f2d3d;
  text-align: center;
}

.login-btn {
  width: 100%;
}

.hint {
  margin-top: 12px;
  font-size: 12px;
  color: #8c98a4;
  text-align: center;
}

.company {
  position: relative;
  z-index: 1;
  font-size: 13px;
  color: #5c6670;
  text-align: center;
  padding-bottom: 6px;
}
</style>
